import React from 'react'
import { Helmet } from 'react-helmet'
import NavBar from '@cmp/site/NavBar'
import MobileMenu from '@cmp/site/MobileMenu'
import { useLanguage } from '@kogk/gatsby-plugin-i18n'
import BaseLayout from './BaseLayout'
import Modal from '@cmp/sections/Modal'
import styles from './MainLayout.module.scss'
import favicon from '@root/static/favicon.jpg'
import { SEO } from '@islandsstofa/react'
import useGetSeoProperties from '@src/hooks/useGetSeoProperties'

const MainLayout: React.FC = ({ children }) => {
  const { t } = useLanguage()

  return (
    <BaseLayout>
      <Meta />

      <a href='#main-content' className={styles.skipToMain}>
        {t('jump to content')}
      </a>

      <Modal />
      <main id='main-content' className={styles.main}>
        <NavBar />
        <MobileMenu />
        {children}
      </main>
    </BaseLayout>
  )
}

const Meta = () => {
  const meta = useGetSeoProperties()
  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <link data-react-helmet='true' rel='icon' href={favicon} />
      </Helmet>
      <SEO {...meta} />
    </>
  )
}

export default MainLayout
